import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CoreTaskService } from '../core-task.service';
import { Observable } from 'rxjs/Observable';
import { CoreTask } from 'app/students/core-task';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { MatSnackBar } from '@angular/material';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';
import { takeUntil } from 'rxjs/operators';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';

@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.scss']
})
export class StudentComponent implements OnInit, OnDestroy {
  private routeSubscription: Subscription;
  private coreTasksSubscription: Subscription;

  private startedCoreTasksSubject = new Subject<CoreTask[]>();
  public startedCoreTasks$ = this.startedCoreTasksSubject.asObservable();

  private unstartedCoreTasksSubject = new Subject<CoreTask[]>();
  public unstartedCoreTasks$ = this.unstartedCoreTasksSubject.asObservable();

  private finishedCoreTasksSubject = new Subject<CoreTask[]>();
  public finishedCoreTasks$ = this.finishedCoreTasksSubject.asObservable();

  constructor(
    private route: ActivatedRoute,
    private coreTaskService: CoreTaskService,
    private snackbar: SemsoSnackbarService) { }

  ngOnInit() {
    this.subscribe();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.coreTasksSubscription.unsubscribe();
  }

  private subscribe() {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.coreTasksSubscription = this.coreTaskService
        .getCoreTasksByStudentAndCreboId(params['studentIdEncrypted'], params['creboId'])
        .subscribe(data => {
          this.unstartedCoreTasksSubject.next(data.filter(item => {
            return item.status === 1;
          }));

          this.startedCoreTasksSubject.next(data.filter(item => {
            return item.status === 2
          }));

          this.finishedCoreTasksSubject.next(data.filter(item => {
            return item.status === 3;
          }));
        });
    });

    this.coreTaskService.retrievalError$.subscribe(data => {
      this.snackbar.error('Fout bij het ophalen van core tasks');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/students/student/student.component.ts